// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608210434/js/" + chunkId + "." + {"44":"86f061ae","225":"1daca81b","481":"aad67147","486":"fac265c6","770":"ba154191"}[chunkId] + ".0.7202222125055879.chunk.js";
};